module.exports = require('./ErrorBoundary')
